/**
 * 게시판 글쓰기·고치기에 쓸 편집기 (2026-10-14 사용자 지시 — AxiEditor 를 반영한다).
 *
 * 기본은 `'axi'`(AxiEditor). `VITE_BOARD_EDITOR=tiptap` 으로 빌드하면 종전 tiptap 편집기로 돌아간다 —
 * 되돌리기가 env 한 줄이 되도록 tiptap 경로를 지우지 않고 남겼다.
 */
export type BoardEditorKind = 'axi' | 'tiptap';

export function boardEditorKind(raw: string | undefined = import.meta.env.VITE_BOARD_EDITOR): BoardEditorKind {
  return raw === 'tiptap' ? 'tiptap' : 'axi';
}

export const BOARD_EDITOR: BoardEditorKind = boardEditorKind();
